let DATA_REQUEST_FORM_OBJECT = {
   "applicantId": "",  
   "firstName": "",
   "lastName": "",
   "phoneNumber": "", 
   "userEmail": "", 
   "dob": "", 
   "emergencyContactName": "", 
   "emergencyPhoneNumber": "", 
   "birthCountry": "",
   "citizenshipCountry" : "",
   "citizenship": "",
   "homeInstitution": "", 
   "livedInUSA": "", 
   "previousBCHEmployee": "", 
   "previousEmploymentDate_start": "", 
   "previousEmploymentDate_end": "", 
   "previousEmploymentDate": "", 
   "previousEmployeeId": "", 
   "ssnLastFourDigits": ""
};

export {DATA_REQUEST_FORM_OBJECT};